import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { StyledContent } from '@/components/styles'
import { Specialist } from '@/components'

const Specialists = ({ data, items = 3 }) => {
  return (
    <StyledContent.Specialists items={items}>
      <TransitionGroup component={null} exit={false}>
        {!!data.length && data.map(specialist => {
          const { id } = specialist
          return (
            <CSSTransition
              in={true}
              key={id}
              timeout={{
                appear: 0,
                enter: 400,
                exit: 0,
              }}
              classNames="on"
            >
              <Specialist key={id} {...specialist} />
            </CSSTransition>
          )
        })}
      </TransitionGroup>
    </StyledContent.Specialists>
  )
}

export default Specialists
